import {blackColor} from "assets/jss/material-dashboard-pro-react.js";
import { grayColor } from "assets/jss/material-dashboard-pro-react.js";
  
  const agendaStyle = {
    cardIconTitle: {
      color: blackColor
    },
    cardAvatarProfileDashboard: {
        height: '30px',
        width: '30px',
        margin: '0'
    },
    cardCategory: {
        marginTop: '20px;',
        color: blackColor
    },
    modalCloseButton: {
      color: grayColor[0],
      marginTop: "-12px",
      WebkitAppearance: "none",
      padding: "0",
      cursor: "pointer",
      background: "0 0",
      border: "0",
      fontSize: "inherit",
      opacity: ".9",
      textShadow: "none",
      fontWeight: "700",
      lineHeight: "1",
      float: "right",
    },
    modalHeader: {
      borderBottom: "none",
      paddingTop: "24px",
      paddingRight: "24px",
      paddingBottom: "0",
      paddingLeft: "24px",
      minHeight: "16.43px"
    },
    modalTitle: {
      margin: "0",
      lineHeight: "1.42857143"
    },    
    modalLarge: {
      maxWidth: "800px",
      width: '80%'
    },
    noMargin: {
      margin: "0"
    },
    overflowHidden: {
      overflow: 'hidden'
    },
    modalLG: {
      minWidth: '450px'
    },
    textRight: {
      textAlign: 'right'
    },
    cardAgenda:{
      marginTop:'0px'
    },    
    boxLegendaDetail:{
      border:'1px solid #c2c2c2',
      background: 'white',
      padding: '10px',
      marginTop: '5px',
      width: '130px',
      position: 'absolute',
      borderRadius:'3px',
      right:'0',
      fontSize:'12px',
      display:'none'
    },
    boxLegenda:{
      display: 'block',
      border: '1px solid #b3b3b3',
      background: '#c8c8c8',
      width: '67px',
      paddingLeft: '8px',
      borderRadius: '5px',
      color: '#787878',
      fontSize: '13px',
      fontWeight: 500,
      height: '27px',
      lineHeight: '24px',
      zIndex: '1030',
      position: 'absolute',
      top: '25px',
      right: '70px',
      cursor:'pointer',
      "&:hover": {
        background: "#b3b3b3", 
        "& $boxLegendaDetail": {
          display: "block", 
        }       
      }
    },
    boxLegendaDetailTitle:{
      display:'block'
    },
    itemLegenda:{
      background: 'gray',
      width: '10px',
      height: '10px',
      display: 'inline-block',
      marginRight: '5px',
    },
    itemLPendente:{
      background: '#3ac3d5',
    },
    itemLConfirmado:{
      background: '#64b067',
    },
    itemLCancelado:{
      background: '#df453a',
    },
    itemLCompareceu:{
      background: '#7839b2',
    },
    itemLFaltou:{
      background: '#eda02f',
    }
    
  }; 
  
  export default agendaStyle;